export const messages = {
  en: {
    addPrivilegeView: {
      title: 'Menu Privilege',
      privilegeName: 'Privilege Name',
      privilegeNamePlaceholder: 'Required, please enter privilege name',
      privilegeNameRequired: 'Privilege name is required',
      resourcePath: 'Resource Path',
      resourcePathPlaceholder: 'Required, please enter resource path',
      resourcePathRequired: 'Resource path is required',
      storeType: 'Store Type',
      storeTypePlaceholder: 'Required, please select store type',
      storeTypeRequired: 'Store type is required',
      description: 'Description',
      descriptionPlaceholder: 'Optional, please enter description',
      operationTeam: 'Operation Team',
      merchant: 'Merchant',
      devTeam: 'Development Team'
    }
  },
  zh: {
    addPrivilegeView: {
      title: '菜单权限',
      privilegeName: '权限名称',
      privilegeNamePlaceholder: '必填，请填写权限名称',
      privilegeNameRequired: '权限名称不能为空',
      resourcePath: '资源路径',
      resourcePathPlaceholder: '必填，请填写资源路径',
      resourcePathRequired: '资源路径不能为空',
      storeType: '商户类型',
      storeTypePlaceholder: '必填，请选择商户类型',
      storeTypeRequired: '商户类型不能为空',
      description: '描述',
      descriptionPlaceholder: '选填，请填写描述',
      operationTeam: '运营团队',
      merchant: '商家',
      devTeam: '开发团队'
    }
  }
}